const allowedDomains = process.env.REACT_APP_ALLOWED_DOMAINS?.split(';');

export const isAllowedDomain = (hostname: string) => allowedDomains?.some((domain) => hostname.includes(domain));
